// src/components/Header.jsx
import {
  AppBar, Toolbar, Container, Button, Box, Stack, Link as MuiLink,
  IconButton, Drawer, List, ListItemButton, ListItemText, Divider
} from '@mui/material';
import { useState } from 'react';

function BurgerIcon(props) {
  return (
    <Box
      aria-hidden
      sx={{
        position: 'relative',
        width: 22, height: 2, bgcolor: 'text.primary',
        '&::before, &::after': {
          content: '""', position: 'absolute', left: 0, width: '100%', height: 2, bgcolor: 'text.primary'
        },
        '&::before': { top: -6 },
        '&::after':  { top:  6 },
      }}
      {...props}
    />
  );
}

import { useAppConfig } from '../../../shared/components/utils/AppConfig';

export function Header() {
  const { appConfig } = useAppConfig();
  const [open, setOpen] = useState(false);
  const go = (p) => () => { window.location.href = p; };

  const logoUrl = appConfig?.branding?.logoUrl || "/public/img/adevslogo.png";
  const appTitle = appConfig?.app?.name || "AguayoDevs";

  const NavInline = () => (
    <Stack
      direction="row"
      spacing={{ xs: 1, sm: 1.5 }}
      alignItems="center"
      sx={{ display: { xs: 'none', md: 'flex' } }}
    >
      <MuiLink href="/" underline="none" color="inherit"
        sx={{ px: 1.25, py: .75, borderRadius: 1, '&:hover': { bgcolor: 'action.hover' } }}>
        Inicio
      </MuiLink>
      <Button variant="outlined" size="small" onClick={go('/adevs-client/register')}>Registro</Button>
      <Button variant="contained" size="small" onClick={go('/adevs-client/login')}>Login</Button>
    </Stack>
  );

  const NavDrawer = () => (
    <>
      <IconButton
        onClick={() => setOpen(true)}
        sx={{ ml: 1, display: { xs: 'inline-flex', md: 'none' } }}
        aria-label="Abrir menú"
      >
        <BurgerIcon />
      </IconButton>
      <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
        <Box sx={{ width: 300, p: 1.5 }}>
          <List>
            <ListItemButton component="a" href="/" onClick={() => setOpen(false)}>
              <ListItemText primary="Inicio" />
            </ListItemButton>
          </List>
          <Divider sx={{ my: 1 }} />
          <Stack direction="row" spacing={1} sx={{ px: 2, pb: 2 }}>
            <Button fullWidth variant="outlined" onClick={go('/adevs-client/register')}>Registro</Button>
            <Button fullWidth variant="contained" onClick={go('/adevs-client/login')}>Login</Button>
          </Stack>
        </Box>
      </Drawer>
    </>
  );

  return (
    <AppBar
      position="sticky"
      color="default"
      elevation={0}
      sx={{
        borderRadius: 0,
        borderBottom: (t) => `1px solid ${t.palette.divider}`,
        backgroundColor: (t) =>
          t.palette.mode === 'dark' ? 'rgba(21,25,34,.82)' : 'rgba(255,255,255,.88)',
        backdropFilter: 'saturate(1.8) blur(8px)',
      }}
    >
      <Container maxWidth="lg" disableGutters>
        <Toolbar
          sx={{
            minHeight: 64,
            px: { xs: 1, sm: 2 },             // menos padding en móviles
            gap: 1,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Box 
            component="img" 
            src={logoUrl} 
            alt={appTitle} 
            sx={{ height: 32, width: 'auto', mr: 1.5, cursor: 'pointer' }} 
            onClick={go('/')}
          />
          <Box sx={{ fontWeight: 800, letterSpacing: '.2px', whiteSpace: 'nowrap', cursor: 'pointer' }} onClick={go('/')}>
            {appTitle}
          </Box>
          <Box sx={{ flexGrow: 1 }} />
          <NavInline />
          <NavDrawer />
        </Toolbar>
      </Container>
    </AppBar>
  );
}
